import { useContext, useEffect } from "react";
import { Flex, Text, VStack, Box } from "@chakra-ui/react";
import { TakeoutContext } from "../../../context/TakeoutContext";
import QRCode from "react-qr-code";

const REMOVE_PHRASES = ["Noodle", "Pork & Veggie", "Kinds of"];

function PrintFormat({
  takeoutCart,
  orderPrice,
  name,
  phone,
  address,
  method,
  history,
  time,
  orderNote,
  table,
  copy,
  currentInvoiceNumber,
  skipCode,
  schedule,
  scheduledTime,
  sequenceNumber,
}) {
  const dayjs = require("dayjs");
  var now = dayjs();

  const { sequenceNumberCounter } = useContext(TakeoutContext);

  const sauceSymbolsComboOne = [
    //{ code: "Q2", color: "red" },
    { code: "Q5", color: "red" },
    { code: "Q6", color: "red" },
  ];
  const sauceSymbolsDinnerCombo = [
    //{ code: "D2", color: "red" },
    { code: "D5", color: "red" },
    { code: "D6", color: "red" },
  ];

  const sauceSymbols = [
    { code: "A4", color: "red" },
    { code: "S1", color: "red" },
    { code: "C8", color: "red" },
    { code: "C9", color: "yellow" },
  ];
  const getColorComboOne = (code) => {
    for (let i = 0; i < sauceSymbolsComboOne.length; i++) {
      if (code === sauceSymbolsComboOne[i].code) {
        return sauceSymbolsDinnerCombo[i].color.charAt(0).toUpperCase();
      }
    }
  };
  const getColorComboDinner = (code) => {
    for (let i = 0; i < sauceSymbolsDinnerCombo.length; i++) {
      if (code === sauceSymbolsDinnerCombo[i].code) {
        return sauceSymbolsDinnerCombo[i].color.charAt(0).toUpperCase();
      }
    }
  };

  const getColor = (code) => {
    for (let i = 0; i < sauceSymbols.length; i++) {
      if (code === sauceSymbols[i].code) {
        return sauceSymbols[i].color.charAt(0).toUpperCase();
      }
    }
  };

  const getMethodText = () => {
    switch (method) {
      case "1":
        return "Pick Up";
      case "2":
        return "Delivery";
      case "3":
        return "Dine In";
      case "4":
        return `Skip - ${skipCode}`;
      case "5":
        return schedule ? "Scheduled Pickup" : "Online";
      default:
        return "";
    }
  };

  const getCurrentSequenceNumber = () => {
    if (history || currentInvoiceNumber === "Online") {
      return sequenceNumber ? sequenceNumber.toString().padStart(2, "0") : "00";
    }
    return sequenceNumberCounter.toString().padStart(2, "0");
  };

  const totalItems = takeoutCart.reduce(
    (accumulator, obj) => accumulator + obj.quantity,
    0,
  );

  function shortenItemName(name, number) {
    let shortened = name;
    if (number === "M11") {
      return "Singapore Rice Noodle";
    } else {
      REMOVE_PHRASES.forEach((phrase) => {
        const regex = new RegExp(phrase, "gi"); // case-insensitive, global
        shortened = shortened.replace(regex, "").trim();
      });
    }
    return shortened
      .replace(/\s+/g, " ")
      .replace(/^[,\s]+|[,\s]+$/g, "")
      .trim();
  }

  return (
    <Flex m={3} direction="column" width="93%">
      <Flex m={3} direction="column" width="93%">
        <style type="text/css" media="print">
          {`
          @page { 
            size: portrait; 
          }
          .tear-off-bottom {
            position: fixed;
            bottom: 0.5in;
            left: 0;
            width: 50%;
            z-index: 1000;
            background: white;
          }
        `}
        </style>
        {/* Header section - show tear-off for restaurant copy, normal header for customer copy */}
        {copy ? (
          // Restaurant copy - show tear-off section instead of header
          <Box>
            {/* Tear-off restaurant section */}
            <Box
              width="100%"
              border="1px solid black"
              borderRadius="5px"
              p={2}
              bg="white"
              boxShadow="0 -2px 4px rgba(0,0,0,0.1)"
            >
              <Flex justify="space-between" align="center" mb="2px">
                <Text fontSize="md">{method === "3" ? table : name}</Text>
                <Text fontSize="sm">{getCurrentSequenceNumber()}</Text>
              </Flex>

              <Flex justify="space-between" align="center" mb="2px">
                <Text fontSize="md">{getMethodText()}</Text>
                {method !== "4" && (
                  <Text fontSize="md">${orderPrice.total.toFixed(2)}</Text>
                )}
              </Flex>

              {method === "5" && schedule && (
                <Text fontSize="md"> {scheduledTime}</Text>
              )}
            </Box>

            {/* Dashed line for tearing */}
            <Box
              width="100%"
              borderTop="2px dashed black"
              mt="10px"
              mb="10px"
            />
          </Box>
        ) : (
          // Customer copy - show normal header
          <>
            <Text
              fontSize="3xl"
              as="i"
              color=" #d90429"
              textShadow="2px 3px #f9c74f"
              fontFamily="langar"
            >
              Ken's Kowloon Kitchen
            </Text>
            <Flex justify="space-between">
              <Text fontSize="13px">www.kenskowloonkitchen.com</Text>
              <Text fontSize="13px">Order Takeout Online</Text>
            </Flex>
            <Flex justify="space-between">
              <Text fontSize="13px">403-279-4471 & 403-279-4472</Text>
              <Text fontSize="13px">By Glenmore Inn Hotel</Text>
            </Flex>
            <Flex justify="flex-end">
              <Text fontSize="14px">{currentInvoiceNumber}</Text>
            </Flex>
          </>
        )}
        <Box border="1px solid black" mt="5px" borderRadius="5px">
          <Box m={1}>
            <Flex justify="space-between">
              {method === "3" ? <Text>{"Table: " + table}</Text> : null}
              <Text fontSize="lg">{name}</Text>
              <Text fontSize="lg">
                {now.format("MM-DD")}, {history ? time : now.format("HH:mm")}
              </Text>
            </Flex>
            <Flex justify="space-between" align="center">
              <Text fontSize="lg">{phone}</Text>
              {method === "1" ? (
                <Text fontSize="2xl" fontWeight="bold">
                  Pick Up
                </Text>
              ) : method === "2" ? (
                <Text fontSize="2xl" fontWeight="bold">
                  Delivery
                </Text>
              ) : method === "3" ? (
                <Text fontSize="2xl" fontWeight="bold">
                  Dine In
                </Text>
              ) : method === "4" ? (
                <Text fontSize="2xl" fontWeight="bold">
                  Skip - {skipCode}
                </Text>
              ) : method === "5" ? (
                <Text fontSize="xl" fontWeight="bold" color="#CE2029">
                  {schedule ? "For Pickup: " + scheduledTime : "Online"}
                </Text>
              ) : null}
            </Flex>

            {method === "1" || method === "2" ? (
              <>
                <Flex justify="space-between">
                  {method === "2" ? <Text fontSize="lg">{address}</Text> : null}
                </Flex>
              </>
            ) : null}
          </Box>
        </Box>
        <VStack
          spacing={1}
          align="stretch"
          mt="2rem"
          width="100%"
          border="1px solid black"
          borderRadius="5px"
        >
          {takeoutCart.map((item, i) => {
            return (
              <Flex
                mt="6px"
                key={"tkoc" + i}
                direction="column"
                width="98%"
                alignSelf="center"
                borderBottom={
                  i === takeoutCart.length - 1 && orderNote === ""
                    ? "0px dashed black"
                    : "1px dashed black"
                }
              >
                <Flex>
                  <Text fontWeight="bold">
                    {item.number}. {shortenItemName(item.name, item.number)} (
                    {item.chineseName})
                  </Text>

                  <Text
                    border={
                      getColor(item.number) === "R"
                        ? "1px solid #CE2029"
                        : getColor(item.number) === "Y"
                          ? "1px solid #fca311"
                          : "0px"
                    }
                    color={
                      getColor(item.number) === "R"
                        ? "#CE2029"
                        : getColor(item.number) === "Y"
                          ? "#fca311"
                          : "black"
                    }
                    ml="8px"
                    borderRadius="50%"
                    lineHeight="18px"
                    width="20px"
                    height="20px"
                    textAlign="center"
                    verticalAlign="center"
                    mt="2px"
                  >
                    {getColor(item.number)}
                  </Text>

                  <Flex ml="auto" direction="column">
                    <Text
                      border={
                        item.quantity > 1 || item.half
                          ? "1px solid #CE2029"
                          : "1px solid black"
                      }
                      borderRadius="50%"
                      lineHeight="19px"
                      width="22px"
                      height="22px"
                      textAlign="center"
                      verticalAlign="center"
                      color={
                        item.quantity > 1 || item.half ? "#CE2029" : "black"
                      }
                      alignSelf="flex-end"
                      fontWeight="bold"
                    >
                      {item.half ? ".5" : item.quantity}
                    </Text>
                  </Flex>
                </Flex>

                <Flex direction="column">
                  <Flex>
                    <Flex direction="column" mb="4px">
                      {item.includes &&
                        item.includes.map((selection, j) => {
                          if (selection.chineseName !== "hidden") {
                            return (
                              <Text key={"incj" + j} as="i" ml="20px">
                                {selection.name} ({selection.chineseName})
                              </Text>
                            );
                          } else {
                            return "";
                          }
                        })}
                      {item.special
                        ? item.comboPickedItems.map((selection, k) => {
                            return (
                              <Flex key={"don" + k}>
                                <Text ml="20px" as="i">
                                  - {selection.code} {selection.name} (
                                  {selection.chineseName}){" "}
                                </Text>
                                <Text
                                  ml="8px"
                                  border={
                                    getColorComboOne(selection.code) === "R"
                                      ? "1px solid #CE2029"
                                      : getColorComboOne(selection.code) === "Y"
                                        ? "1px solid #fca311"
                                        : "0px"
                                  }
                                  color={
                                    getColorComboOne(selection.code) === "R"
                                      ? "#CE2029"
                                      : getColorComboOne(selection.code) === "Y"
                                        ? "#fca311"
                                        : "black"
                                  }
                                  borderRadius="50%"
                                  lineHeight="18px"
                                  width="20px"
                                  height="20px"
                                  textAlign="center"
                                  verticalAlign="center"
                                  mt="2px"
                                >
                                  {getColorComboOne(selection.code)}
                                </Text>
                              </Flex>
                            );
                          })
                        : null}
                      {item.combo
                        ? item.comboPickedItems.map((selection, k) => {
                            return (
                              <Flex key={"pkt" + k}>
                                <Text ml="20px" as="i">
                                  - {selection.code} {selection.name} (
                                  {selection.chineseName})
                                </Text>
                                <Text
                                  ml="8px"
                                  border={
                                    getColorComboDinner(selection.code) === "R"
                                      ? "1px solid #CE2029"
                                      : getColorComboDinner(selection.code) ===
                                          "Y"
                                        ? "1px solid #fca311"
                                        : "0px"
                                  }
                                  color={
                                    getColorComboDinner(selection.code) === "R"
                                      ? "#CE2029"
                                      : getColorComboDinner(selection.code) ===
                                          "Y"
                                        ? "#fca311"
                                        : "black"
                                  }
                                  borderRadius="50%"
                                  lineHeight="18px"
                                  width="20px"
                                  height="20px"
                                  textAlign="center"
                                  verticalAlign="center"
                                  mt="2px"
                                >
                                  {getColorComboDinner(selection.code)}
                                </Text>
                              </Flex>
                            );
                          })
                        : null}
                      {item.itemSize !== undefined ? (
                        <Text ml="20px" as="i">
                          {"- " +
                            item.itemSize.charAt(0).toUpperCase() +
                            item.itemSize.slice(1)}
                        </Text>
                      ) : null}

                      <Text ml="20px" as="i" color="#CE2029" fontSize="15px">
                        {item.note !== "" ? "*- " + item.note : null}
                      </Text>
                    </Flex>
                    <Text ml="auto">
                      {method !== "4" ? (
                        item.soupDiscountFlag ? (
                          //discounted soup price
                          <Text>${item.soupDiscountPrice.toFixed(2)}</Text>
                        ) : (
                          <Text>
                            ${(item.price * item.quantity).toFixed(2)}
                          </Text>
                        )
                      ) : null}
                    </Text>
                  </Flex>
                </Flex>
              </Flex>
            );
          })}
          <Text
            fontWeight="bold"
            ml="20px !important"
            color="#CE2029"
            mb="4px !important"
          >
            {orderNote !== "" ? "*Note: " + orderNote : null}
          </Text>
        </VStack>
        {method !== "4" ? (
          <Flex
            color="black"
            fontWeight="bold"
            direction="row"
            mt="7px"
            justify="space-between"
          >
            <Flex direction="column">
              <Text fontSize="14px">{totalItems}</Text>
              <QRCode size={55} value={"http://kenskowloonkitchen.com/"} />
              <Text fontWeight="normal" fontSize="smaller" mt="auto">
                GST: 74518 0810 RT0001
              </Text>
            </Flex>
            <Flex direction="column" align="flex-end">
              <Text color="#2A3439">
                Subtotal: ${orderPrice.subTotal.toFixed(2)}
              </Text>

              {orderPrice.additionalCharges !== 0 ? (
                <Text color="#2A3439">
                  {parseFloat(orderPrice.additionalCharges) < 0
                    ? "Discount: -$" +
                      parseFloat(orderPrice.additionalCharges * -1).toFixed(2)
                    : "Charges: +$" +
                      parseFloat(orderPrice.additionalCharges).toFixed(2)}
                </Text>
              ) : null}
              {(orderPrice.subTotal >= 40.0) &
              (method === "1" || method === "5") ? (
                <>
                  <Text color="#2A3439">
                    Discount (5%): ${orderPrice.discount.toFixed(2)}
                  </Text>
                </>
              ) : null}
              {method === "2" ? (
                <Text color="#2A3439">
                  Driver Fee: ${orderPrice.deliveryFee.toFixed(2)}
                </Text>
              ) : null}
              <Text color="#2A3439">Tax: ${orderPrice.gst.toFixed(2)}</Text>
              <Text fontSize="18px">Total: ${orderPrice.total.toFixed(2)}</Text>
            </Flex>
          </Flex>
        ) : null}
        <Flex
          position="fixed"
          top="0"
          right={copy ? "52%" : "1"}
          sx={{
            display: "none",
            "@media print": {
              display: "block",
            },
          }}
        >
          <Text fontSize="8px">{getCurrentSequenceNumber()}</Text>
        </Flex>

        {/* Current Customer/Restaurant Copy indicator */}
        <Flex
          align="end"
          justify="center"
          fontWeight="normal"
          width="100%"
          mt="10px"
          mb="10px"
        >
          <Text as="i" justify="center">
            {copy ? "Restaurant Copy" : "Customer Copy"}
          </Text>
        </Flex>
      </Flex>
    </Flex>
  );
}

export default PrintFormat;
